import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-sgkb106d',
  templateUrl: './sgkb106d.component.html',
  styleUrl: './sgkb106d.component.scss'
})
export class Sgkb106dComponent implements OnInit, OnDestroy {
    /**
   * 初期処理
   * @memberof Sgkb106dComponent
   */
  ngOnInit(): void {
    // Do nothing.
  }

  ngOnDestroy(): void {
    // Do nothing.
  }

  onClose() {
    window.close();
  }
}
